module.exports = __webpack_public_path__ + "img/Folded_Paper_case_thumbnail_Avans_Hogeschool.93ea23ea.jpg";